var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFaqBilling(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 166 152",
    style: {
      enableBackground: "new 0 0 166 152"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#FFCB03;stroke-width:3;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BILLING"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M133.67,13.22H96.82H57.24h-8.61c4.74,0,8.61,3.87,8.61,8.61v2.32v90.95v10.02v16.96h1.34 c0-1.69,1.37-3.06,3.06-3.06c1.69,0,3.06,1.37,3.06,3.06h1.74c0-1.69,1.37-3.06,3.06-3.06c1.69,0,3.06,1.37,3.06,3.06h1.74 c0-1.69,1.37-3.06,3.06-3.06c1.69,0,3.06,1.37,3.06,3.06h1.74c0-1.69,1.37-3.06,3.06-3.06s3.06,1.37,3.06,3.06h1.74 c0-1.69,1.37-3.06,3.06-3.06c1.69,0,3.06,1.37,3.06,3.06h1.74c0-1.69,1.37-3.06,3.06-3.06c1.69,0,3.06,1.37,3.06,3.06h1.74 c0-1.69,1.37-3.06,3.06-3.06c1.69,0,3.06,1.37,3.06,3.06h1.74c0-1.69,1.37-3.06,3.06-3.06s3.06,1.37,3.06,3.06h1.74 c0-1.69,1.37-3.06,3.06-3.06c1.69,0,3.06,1.37,3.06,3.06h1.74c0-1.69,1.37-3.06,3.06-3.06s3.06,1.37,3.06,3.06h1.74 c0-1.69,1.37-3.06,3.06-3.06s3.06,1.37,3.06,3.06h1.7V24.55C145,18.29,139.93,13.22,133.67,13.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.63,13.22L48.63,13.22c-4.74,0-8.61,3.87-8.61,8.61v34.13v59.14v1.41c0,4.74-3.87,8.61-8.61,8.61h8.61 h17.22V115.1V21.83C57.24,17.09,53.37,13.22,48.63,13.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.46,55.95c0,1.69-1.37,3.06-3.06,3.06c-1.69,0-3.06-1.37-3.06-3.06H30.6c0,1.69-1.37,3.06-3.06,3.06 c-1.69,0-3.06-1.37-3.06-3.06H22.8v60.55c0,4.74,3.87,8.61,8.61,8.61l0,0c4.74,0,8.61-3.87,8.61-8.61V55.95H38.46z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 66.29,
    y1: 39.12,
    x2: 135.37,
    y2: 39.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 67.07,
    y1: 51.68,
    x2: 136.15,
    y2: 51.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 67.07,
    y1: 64.24,
    x2: 136.15,
    y2: 64.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 67.07,
    y1: 76.8,
    x2: 136.15,
    y2: 76.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 67.07,
    y1: 89.36,
    x2: 136.15,
    y2: 89.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 67.07,
    y1: 101.92,
    x2: 136.15,
    y2: 101.92
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqBilling);
export default __webpack_public_path__ + "static/media/faq-billing.68df5cd6b67265eaa01c2950f9be46ad.svg";
export { ForwardRef as ReactComponent };